<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="8"/>
		<section class="n_banner" style="overflow: hidden;display: flex;align-items: center;">
			<img :src="bannerurl" style="width: 100%;height: 100%;">
		</section>
		<section class="n_title n_title01">
			<div class="w1400 pagetit">
				<div class="left">
					<div class="n_nav">
						<a v-for="(item, index) in newsmenu" :key="index" :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						<!-- <a class="on" href="#"><strong>人才招聘</strong></a>
						<a href="#"><strong>招商加盟</strong></a> -->
					</div>
				</div>
				<div class="right ">
					<div class="position"><a href="#">首页</a> <i>-</i> <a href="/joinus?type=&index=7">加入我们</a> <i>-</i> <em>{{newstabname}}</em> </div>
				</div>
			</div>
		</section>
		<section class="n_container">
			<div class="w1400">
				<ul v-if="showzp" class="zhaopin">
					<li v-for="(item,index) in worklist" :key="index">
						<el-button type="text" @click="showworkinfo(index)">
							<a>
							<div class="top">
								<div class="ll fl">
									<h5>{{item.title}}</h5>
									<h6><img src="../assets/images/n_jairu_fl03_icon.png" alt="">工作地点：{{item.workLocation}} 人数：{{item.count}}</h6>
								</div>              
								<div class="rr fr">
									<div class="box_table">
										<div class="box_table_cell">
											<div class="line">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="bottom">
								<h5>岗位职责</h5>
								<div v-html="item.details"></div>
							</div>
							</a>
						</el-button>
					</li>
					
					<!-- <li>
						<a href="#">
							<div class="top">
								<div class="ll fl">
									<h5>销售业务员</h5>
									<h6><img src="../assets/images/n_jairu_fl03_icon.png" alt="">工作地点：全国分配 人数：若干</h6>
								</div>              
								<div class="rr fr">
									<div class="box_table">
										<div class="box_table_cell">
											<div class="line">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="bottom">
								<h5>岗位职责</h5>
								<p>任职要求：1. 负责经销商拓展与客情维护；2. 负责团购、烟酒店等渠道拓展；3.负责公司营销政策执行；4.保质保量完成分办下达的销售任务、过程指标等各项工作。</p>
							</div>
						</a>
					</li>
					<li>
						<a href="#">
							<div class="top">
								<div class="ll fl">
									<h5>销售业务员</h5>
									<h6><img src="../assets/images/n_jairu_fl03_icon.png" alt="">工作地点：全国分配 人数：若干</h6>
								</div>              
								<div class="rr fr">
									<div class="box_table">
										<div class="box_table_cell">
											<div class="line">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="bottom">
								<h5>岗位职责</h5>
								<p>任职要求：1. 负责经销商拓展与客情维护；2. 负责团购、烟酒店等渠道拓展；3.负责公司营销政策执行；4.保质保量完成分办下达的销售任务、过程指标等各项工作。</p>
							</div>
						</a>
					</li>
					<li>
						<a href="#">
							<div class="top">
								<div class="ll fl">
									<h5>销售业务员</h5>
									<h6><img src="../assets/images/n_jairu_fl03_icon.png" alt="">工作地点：全国分配 人数：若干</h6>
								</div>              
								<div class="rr fr">
									<div class="box_table">
										<div class="box_table_cell">
											<div class="line">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="bottom">
								<h5>岗位职责</h5>
								<p>任职要求：1. 负责经销商拓展与客情维护；2. 负责团购、烟酒店等渠道拓展；3.负责公司营销政策执行；4.保质保量完成分办下达的销售任务、过程指标等各项工作。</p>
							</div>
						</a>
					</li>
					<li>
						<a href="#">
							<div class="top">
								<div class="ll fl">
									<h5>销售业务员</h5>
									<h6><img src="../assets/images/n_jairu_fl03_icon.png" alt="">工作地点：全国分配 人数：若干</h6>
								</div>              
								<div class="rr fr">
									<div class="box_table">
										<div class="box_table_cell">
											<div class="line">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="bottom">
								<h5>岗位职责</h5>
								<p>任职要求：1. 负责经销商拓展与客情维护；2. 负责团购、烟酒店等渠道拓展；3.负责公司营销政策执行；4.保质保量完成分办下达的销售任务、过程指标等各项工作。</p>
							</div>
						</a>
					</li>
					<li>
						<a href="#">
							<div class="top">
								<div class="ll fl">
									<h5>销售业务员</h5>
									<h6><img src="../assets/images/n_jairu_fl03_icon.png" alt="">工作地点：全国分配 人数：若干</h6>
								</div>              
								<div class="rr fr">
									<div class="box_table">
										<div class="box_table_cell">
											<div class="line">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="bottom">
								<h5>岗位职责</h5>
								<p>任职要求：1. 负责经销商拓展与客情维护；2. 负责团购、烟酒店等渠道拓展；3.负责公司营销政策执行；4.保质保量完成分办下达的销售任务、过程指标等各项工作。</p>
							</div>
						</a>
					</li>
					 -->
				</ul>
				<div v-else v-html="worklist.content" style="padding: 30px 0px;">
					
				</div>
			</div>
		</section>
		<el-dialog title="招聘信息" :visible.sync="dialogVisible" width="40%">
		  <div class="wordsty">{{jobname}}</div>
			<div class="wordsty">工作地点：{{jobaddr}} 人数：{{jobcount}}</div>
			<!-- <div class="wordsty">岗位职责</div> -->
			<div class="wordsty" v-html="showinfo"></div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="senduserind">投 递</el-button>
		  </span>
		</el-dialog>
		<el-dialog title="简历投递" :visible.sync="dialogFormVisible" width="40%">
		  <el-form :model="form">
		    <el-form-item label="姓名" :label-width="formLabelWidth">
		      <el-input v-model="form.name" autocomplete="off"></el-input>
		    </el-form-item>
		    <el-form-item label="联系方式" :label-width="formLabelWidth">
		      <el-input v-model="form.phone" autocomplete="off"></el-input>
		    </el-form-item>
				<el-form-item label="性别" :label-width="formLabelWidth">
					<el-select v-model="form.gender" placeholder="请选择性别">
						<el-option label="男" value="1"></el-option>
						<el-option label="女" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="电子邮箱" :label-width="formLabelWidth">
				  <el-input v-model="form.email" autocomplete="off"></el-input>
				</el-form-item>	
				<el-form-item label="上传简历" :label-width="formLabelWidth">
				  <!-- <el-input v-model="form.name" autocomplete="off"></el-input> -->
					<el-upload class="upload-demo" :action="'http://www.shuanggou.com/sgapi/w/img/upload?recruitmentCode='+form.code" :on-success="handleChange" :file-list="fileList" accept=".pdf">
					  <div style="display: flex;justify-content: flex-start;">
					  	<el-button size="small" type="primary">点击上传</el-button>
					  	<div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
					  </div>
					</el-upload>
				</el-form-item>	
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="sendjianli">提 交</el-button>
		  </div>
		</el-dialog>
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
	  name: 'product',
		components: {
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				imgurl:this.COMMON.imgurl,
				newsmenu:[],
				newstabind:0,
				newstabname:'',
				worklist:[],
				bannerurl:'',
				oldcode:'',
				menuindex:'',
				dialogVisible: false,
				dialogFormVisible:false,
				showinfo:'',
				jobname:'',
				jobaddr:'',
				jobcount:'',
				form:{
					name:'',
					phone:'',
					gender:'',
					email:'',
					resumePath:'',
					code:''
				},
				formLabelWidth: '120px',
				fileList: [],
				showzp:true
			}
		},
		computed:{
			
		},
		mounted() {
			let that = this
			let artcode = this.$route.query.type
			let artind = this.$route.query.ind
			let menuindex = this.$route.query.index
			that.oldcode = this.$route.query.type
			that.newstabind = this.$route.query.ind
			that.menuindex = this.$route.query.index
			// 新闻
			this.getmenulist()
			that.$axios.post('/w/menu').then(function (response) {
				that.bannerurl = that.imgurl + response.data[7].banner
			}).catch(function (error) {
					console.log(error);
			});
			
			that.$axios.post('/w/pageseo?address='+'/joinus').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			getrecruitment(){
				let that = this
				this.$axios.post('/w/recruitment?amount=&&page=&&code=').then(function (response) {
					that.worklist = response.data
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getmenulist(){
				let that = this
				this.$axios.post('/w/menu?code=1631174264673').then(function (response) {
					if(that.oldcode && that.newstabind){
						that.newstabname = response.data[that.newstabind].title
						if(response.data[that.newstabind].linkContent == 'rczp'){
							that.getrecruitment()
							that.showzp=true
						}else{
							that.showzp=false
							that.getnewslist(that.oldcode,that.newstabind)
						}
					}else{
						that.newstabind = 0
						that.newstabname = response.data[that.newstabind].title
						that.getrecruitment()
						// that.getnewslist(response.data[0].code,0)
					}
					that.newsmenu = response.data
					
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getnewslist(num,ind){
				let that = this
				this.$axios.post('/w/art?code=&&amount=&&page=&&menuCode='+num).then(function (response) {
					
					that.worklist = response.data.list[0]
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			otherrout(num,ind){
				this.$router.push({path:'/joinus',query: {type:num,ind:ind}})
			},
			showworkinfo(num){
				if(this.isshow){
					this.dialogVisible = true
					this.showinfo = this.worklist[num].details
					this.form.code = this.worklist[num].code
					this.jobname = this.worklist[num].title
					this.jobaddr = this.worklist[num].workLocation
					this.jobcount = this.worklist[num].count
				}else{
					this.$message({
						message: '请在电脑端投递简历',
						type: 'warning'
					});
				}
			},
			senduserind(){
				this.dialogVisible = false
				this.dialogFormVisible = true
			},
			handleChange(response, file, fileList) {
				this.form.resumePath = response.msg
				this.fileList = fileList.slice(-3);
			},
			sendjianli(){
				let that = this
				if(that.form.name && that.form.phone && that.form.gender && that.form.email && that.form.resumePath){
					that.$axios.post('/w/recruitment/sendcheck?code='+that.form.code+'&name='+that.form.name+'&phone='+that.form.phone).then(function (response) {
						if(response.data.flag == 1){
							that.$axios.post('/w/recruitment/send?code='+that.form.code+'&name='+that.form.name+'&phone='+that.form.phone+'&gender='+that.form.gender+'&email='+that.form.email+'&resumePath='+that.form.resumePath).then(function (response) {
								if(response.data.flag == 1){
									that.dialogFormVisible = false
									that.$message({
										message: '投递成功！',
										type: 'success'
									});
								}
								
							})
							.catch(function (error) {
								console.log(error);
							});
						}else{
							that.$message({
								message: '您已投递过该职位!',
								type: 'warning'
							});
						}
						
					})
					.catch(function (error) {
						console.log(error);
					});
					
					
				}else{
					this.$message({
						message: '请填写完整信息！',
						type: 'warning'
					});
				}
			}
		},
		watch:{
			$route(){
				this.oldcode = this.$route.query.type
				this.newstabind = this.$route.query.ind
				this.getmenulist()
			},
		}
	}
</script>

<style scoped="scoped">
	ul, ol, li {
	    list-style: none;
	}
	img {
	    border-style: none;
	    max-width: 100%;
	    vertical-align: top;
	    width: auto!important;
	    height: auto!important;
	}
	.n_banner {height: 70vh;background-size: cover !important;}
	.n_title {height: 74px;border-bottom: #e7e7ea 1px solid;padding: 0;position: relative;background: #fff;}
	.pagetit{display: flex;justify-content: space-between;}
	.n_nav {position: relative;}
	.n_nav a {display: inline-block;height: 74px;font-size: 18px;float: left;line-height: 75px;color: #333333;text-align: center;box-sizing: border-box;position: relative;-moz-border-radius: 3px;-webkit-border-radius: 3px;border-radius: 3px;margin-right: 3.125rem;}
	.n_nav a:before {content: "";width: 0;height: 3px;position: absolute;bottom: 0;left: 0;background: #119e7f;transition: 0.6s ease-in-out;}
	.n_nav .on:before, .n_nav a:hover:before {width: 100%;}
	.position {line-height: 74px;color: #7b7b7d;padding-left: 22px;font-size: 14px;background: url(../assets/images/home_icon.png) left 30px no-repeat;}
	.position i {
		margin: 0px 5px;
		font-style: normal;
	}
	.position span, .position a, .position i {
		font-size: 14px;
		color: #7b7b7d;
		-moz-transition: all 0.36s ease-in-out;
		-webkit-transition: all 0.36s ease-in-out;
		-o-transition: all 0.36s ease-in-out;
		-ms-transition: all 0.36s ease-in-out;
		transition: all 0.36s ease-in-out;
	}
	.position em {
		font-size: 14px;
		color: #acacac;
		font-style: normal;
	}
	.n_container {
		background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #fff;
		background-size: 100% auto;
		width: 100%;
	}
	.zhaopin {
	    margin: 0 -1rem;
	    padding: 80px 0;
	    font-size: 0;
			text-align: left;
	}
	.zhaopin li {
	    display: inline-block;
	    width: calc(33.333333% - 2rem);
	    padding: 0 1rem;
	    margin-bottom: 2rem;
	}
	.zhaopin li a {
	    display: block;
	    background: #fff;
	    border: 1px solid #ddd;
	    overflow: hidden;
	    padding: 2rem;
			text-align: left;
	}
	.zhaopin li a .top {
	    overflow: hidden;
	    border-bottom: #cccdd1 1px solid;
	    padding-bottom: 2.25rem;
	    margin-bottom: 1.75rem;
			display: flex;
			justify-content: space-between;
	}
	.zhaopin li a .top .ll {
	    width: calc(100% - 3rem);
	    padding-right: 1rem;
	}
	.zhaopin li a .top .rr {
	    display: inline-block;
	    width: 3rem;
	    height: 3rem;
	    border: #cecece 1px solid;
	    transition: 0.6s;
	}
	.zhaopin li a .top .ll h5 {
	    font-family: 'syst';
	    font-size: 24px;
	    color: #474747;
	    height: 24px;
	    line-height: 24px;
	    overflow: hidden;
	    white-space: nowrap;
	    text-overflow: ellipsis;
	    margin-bottom: 20px;
	}
	.zhaopin li a .top .ll h6 {
	    font-size: 14px;
	    color: #929292;
	}
	.zhaopin li a .top .ll h6 img {
	    display: inline-block;
	    margin: 0px 0.5rem 0 0;
	}
	.box_table {
	    display: table;
	    table-layout: fixed;
	    text-align: center;
	    width: 100%;
	    height: 100%;
	}
	.box_table_cell {
	    display: table-cell;
	    vertical-align: middle;
			transition: 0.6s;
	}
	.zhaopin li a .top .rr .line {
	    display: inline-block;
	    width: 15px;
	    height: 15px;
	    position: relative;
	    transition: 0.6s;
	}
	.zhaopin li a .top .rr .line:before {
	    content: "";
	    position: absolute;
	    width: 100%;
	    height: 1px;
	    background: #bbbbbb;
	    top: 50%;
	    margin-top: -0.5px;
	    left: 0;
	    transition: 0.6s;
	}
	.zhaopin li a .top .rr .line:after {
	    content: "";
	    position: absolute;
	    width: 1px;
	    height: 100%;
	    background: #bbbbbb;
	    left: 50%;
	    margin-left: -0.5px;
	    transition: 0.6s;
	}
	.zhaopin li:hover .box_table_cell{background-color: #119e7f;}
	.zhaopin li:hover a .top .rr{border: #119e7f 1px solid;}
	.zhaopin li:hover a .top .rr .line:after{background-color: #ffffff;transform: rotateZ(90deg);}
	.zhaopin li:hover .top .rr .line:before{background-color: #ffffff;transform: rotateZ(90deg);}
	.zhaopin li a .bottom h5 {
	    font-size: 18px;
	    color: #474747;
	    height: 18px;
	    line-height: 18px;
	    margin-bottom: 1.25rem;
	    font-family: 'syst';
	}
	.zhaopin li a .bottom div {
	    /* font-size: 14px;
	    color: #878789;
	    line-height: 28px; */
	    height: 112px;
	    overflow: hidden;
	}
	.wordsty{text-align: left;font-size: 16px;margin: 14px;}
	/deep/ .el-dialog__body{text-align: left !important;}
	/deep/ .el-upload__tip{margin-top: 0px;margin-left: 16px;}
	@media screen and (max-width: 767px) {
		.n_title{height: 50px;}
		.n_nav a{height: 50px;line-height: 50px;}
		.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	  .left{width: 7rem;
	  height: 50px;
	  overflow: hidden;}
		.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
		.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
		.zhaopin li{width: calc(100% - 2rem);}
	}
</style>
